import api from './api'

const adminService = {
  // ============ TOURS MANAGEMENT ============

  // Get all tours for admin (including inactive)
  getAllToursAdmin: async (params = {}) => {
    const response = await api.get('/tours/admin/all', { params })
    return response.data
  },

  // Create new tour
  createTour: async (tourData) => {
    const response = await api.post('/tours', tourData)
    return response.data
  },

  // Update tour
  updateTour: async (id, tourData) => {
    const response = await api.put(`/tours/${id}`, tourData)
    return response.data
  },

  // Delete tour
  deleteTour: async (id) => {
    const response = await api.delete(`/tours/${id}`)
    return response.data
  },

  // Toggle tour active status
  toggleTourStatus: async (id) => {
    const response = await api.patch(`/tours/${id}/toggle-status`)
    return response.data
  },

  // ============ SERVICES MANAGEMENT ============

  // Get all services for admin
  getAllServicesAdmin: async (params = {}) => {
    const response = await api.get('/services', { params })
    return response.data
  },

  // Create new service
  createService: async (serviceData) => {
    const response = await api.post('/services', serviceData)
    return response.data
  },

  // Update service
  updateService: async (id, serviceData) => {
    const response = await api.put(`/services/${id}`, serviceData)
    return response.data
  },

  // Delete service
  deleteService: async (id) => {
    const response = await api.delete(`/services/${id}`)
    return response.data
  },

  // ============ DISCOUNTS MANAGEMENT ============

  // Get all discounts
  getAllDiscounts: async () => {
    const response = await api.get('/discounts')
    return response.data
  },

  // Create discount
  createDiscount: async (discountData) => {
    const response = await api.post('/discounts', discountData)
    return response.data
  },

  // Update discount
  updateDiscount: async (id, discountData) => {
    const response = await api.put(`/discounts/${id}`, discountData)
    return response.data
  },

  // Delete discount
  deleteDiscount: async (id) => {
    const response = await api.delete(`/discounts/${id}`)
    return response.data
  },

  // ============ PROMOTIONAL OFFERS MANAGEMENT ============

  // Get all promotional offers
  getAllPromotionalOffers: async () => {
    const response = await api.get('/discounts/offers')
    return response.data
  },

  // Create promotional offer
  createPromotionalOffer: async (offerData) => {
    const response = await api.post('/discounts/offers', offerData)
    return response.data
  },

  // Update promotional offer
  updatePromotionalOffer: async (id, offerData) => {
    const response = await api.put(`/discounts/offers/${id}`, offerData)
    return response.data
  },

  // Delete promotional offer
  deletePromotionalOffer: async (id) => {
    const response = await api.delete(`/discounts/offers/${id}`)
    return response.data
  },

  // ============ USER-SPECIFIC DISCOUNTS ============

  // Apply discount to specific user
  assignUserDiscount: async (userId, discountCode) => {
    const response = await api.post(`/discounts/assign-user`, { userId, discountCode })
    return response.data
  },

  // Get user's assigned discounts
  getUserDiscounts: async (userId) => {
    const response = await api.get(`/discounts/user/${userId}`)
    return response.data
  },

  // ============ BOOKINGS MANAGEMENT ============

  // Get all bookings
  getAllBookings: async (params = {}) => {
    const response = await api.get('/bookings', { params })
    return response.data
  },

  // Update booking status
  updateBookingStatus: async (id, status) => {
    const response = await api.put(`/bookings/${id}/status`, { status })
    return response.data
  },

  // Confirm booking
  confirmBooking: async (bookingId) => {
    const response = await api.put(`/bookings/${bookingId}/confirm`)
    return response.data
  },

  // Apply admin discount
  applyAdminDiscount: async (bookingId, discountData) => {
    const response = await api.put(`/bookings/${bookingId}/discount`, discountData)
    return response.data
  },

  // Update booking details
  updateBookingDetails: async (bookingId, bookingData) => {
    const response = await api.put(`/bookings/${bookingId}/details`, bookingData)
    return response.data
  },

  // ============ ANALYTICS & STATS ============

  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await api.get('/admin/stats')
    return response.data
  },

  // Get revenue reports
  getRevenueReport: async (startDate, endDate) => {
    const response = await api.get('/admin/revenue', {
      params: { startDate, endDate },
    })
    return response.data
  },
}

export default adminService
